import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "./App.css";
import { COPY } from "./copy";
import { Grain, Cursor } from "./fx";
import { Nav } from "./Nav";
import { Hero, Ticker, Manifesto, Audience, Roadmap } from "./SectionsA";
import { Curriculum, Host, Empathy, Takeaways, Faq, FinalRegister, Footer, MobileCTA } from "./SectionsB";
import { ThankYou } from "./ThankYou";
import { PrivacyPage, TermsPage } from "./LegalPages";
import ReplayPage from "./ReplayPage";

gsap.registerPlugin(ScrollTrigger);

const ScrollTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const Landing = ({ t, lang }) => (
  <>
    <Nav t={t} />
    <Hero t={t} lang={lang} />
    <Ticker t={t} />
    <Manifesto t={t} lang={lang} />
    <Audience t={t} />
    <Roadmap t={t} />
    <Curriculum t={t} />
    <Host t={t} />
    <Empathy t={t} />
    <Takeaways t={t} />
    <Faq t={t} />
    <FinalRegister t={t} lang={lang} />
    <Footer t={t} />
    <MobileCTA t={t} />
  </>
);

export default function App() {
  const lang = "es";
  const t = COPY[lang];

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.1, smoothWheel: true });
    window.__lenis = lenis;
    lenis.on("scroll", ScrollTrigger.update);
    const raf = (time) => lenis.raf(time * 1000);
    gsap.ticker.add(raf);
    gsap.ticker.lagSmoothing(0);
    return () => {
      gsap.ticker.remove(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  useEffect(() => {
    document.documentElement.lang = "es";
    document.title = "La Sesión del Comprador Estratégico — Plinio Angulo";
  }, []);

  return (
    <BrowserRouter>
      <div className="min-h-screen" data-testid="app-root">
        <Grain />
        <Cursor />
        <ScrollTop />
        <Routes>
          <Route path="/" element={<Landing t={t} lang={lang} />} />
          <Route path="/replay" element={<><ReplayPage t={t} lang={lang} /><Footer t={t} /></>} />
          <Route path="/thank-you" element={<><ThankYou t={t} lang={lang} /><Footer t={t} /></>} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}
